export default [
    {
      path: 'meter-list',
      name: 'MeterList',
      component: require('@/components/MeterList'),
    },
    {
      path: 'order-list',
      name: 'OrderList',
      component: require('@/components/OrderList'),
    },
    {
    	path:'order-create/:type/:unit/:metercode',
    	name:'OrderCreate',
    	component:require('@/components/OrderCreate'),
    },
    {
    	path:'change-password',
    	name:'ChangePassword',
    	component:require('@/components/ChangePassword'),
    },
    {
    	path:'add-admin',
    	name:'AddAdmin',
    	component:require('@/components/AddAdmin'),
    },
    {
    	path:'add-code',
    	name:'addCode',
    	component:require('@/components/addCode'),
    },
    {
    	path:'over-draft',
    	name:'overDraft',
    	component:require('@/components/overDraft'),
    },
    {
    	path:'meter-charge',
    	name:'meterCharge',
    	component:require('@/components/meterCharge'),
    },
    {
    	path:'index',
    	name:'index',
    	component:require('@/components/Index'),
    },
    {
    	path:'meter-status',
    	name:'meterStatus',
    	component:require('@/components/meterStatus'),
    },
    {
    	path:'meter-file',
    	name:'meterFile',
    	component:require('@/components/meterFile'),
    },
    {
    	path:'receipt-list',
    	name:'receiptList',
    	component:require('@/components/receipt'),
    },
    {
    	path:'cash',
    	name:'cash',
    	component:require('@/components/cash'),
    },
    {
    	path:'cash-list',
    	name:'cashList',
    	component:require('@/components/cashList'),
    },
    {
    	path:'invoice',
    	name:'invoice',
    	component:require('@/components/invoice'),
    },
    {
    	path:'invoice-list',
    	name:'invoiceList',
    	component:require('@/components/invoiceList'),
    },
    {
    	path:'service-list',
    	name:'serviceList',
    	component:require('@/components/ServiceList'),
    },
    {
    	path:'settlement',
    	name:'settlement',
    	component:require('@/components/settlement'),
    },
    {
    	path:'settlement-list',
    	name:'settlementList',
    	component:require('@/components/settlementList'),
	},
	{
    	path:'small-change/:orderid',
    	name:'smallChange',
    	component:require('@/components/smallChange'),
	},
	{
    	path:'small-re-change/:orderid/:cycle',
    	name:'smallReChange',
    	component:require('@/components/smallReChange'),
	},

	{
    	path:'property',
    	name:'property',
    	component:require('@/components/Property'),
	},
	{
    	path:'PropertyInfoChange',
    	name:'propertyInfoChange',
    	component:require('@/components/PropertyInfoChange'),
	},
	{
    	path:'userSet',
    	name:'userSet',
    	component:require('@/components/UserSet'),
	},

	// 20201110
	{	// 物业缴费提现
    	path:'PropertyWithdrawal',
    	name:'PropertyWithdrawal',
    	component:require('@/components/20201110/PropertyWithdrawal'),
	},
	{	// 物业缴费记录
    	path:'PropertyRecord',
    	name:'PropertyRecord',
    	component:require('@/components/20201110/PropertyRecord'),
	},
	{	// 账目明细
    	path:'AccountDetails',
    	name:'AccountDetails',
    	component:require('@/components/20201110/AccountDetails'),
	},
	{	// 申请发票
    	path:'InvoiceApply',
    	name:'InvoiceApply',
    	component:require('@/components/20201110/InvoiceApply'),
	},
	{	// 发票记录
    	path:'InvoiceRecord',
    	name:'InvoiceRecord',
    	component:require('@/components/20201110/InvoiceRecord'),
	},
	// 
	{	// 发票开关
    	path:'InvoiceSwitch',
    	name:'InvoiceSwitch',
    	component:require('@/components/InvoiceSwitch'),
	},
]



// WEBPACK FOOTER //
// ./src/router/base.js